import styled from "styled-components"

const Container = styled.button`
    background-color: ${({background})=> background};
    color: ${({color})=> color};
    border-radius: ${({radius})=> radius};
    border: 1px solid transparent;
    border-color: ${({borderColor}) => borderColor};
    width: ${({width})=> width};
    padding: ${({padding})=> padding};
    font-size: ${({fontSize})=> fontSize};
    text-align: center;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    font-weight: var(--font-weight-md);
`
const Button = ({text,background, color= "#fff", borderColor="#E85446", width= "320px", radius="10px",handleClick, handleMouseEnter, handleMouseLeave, type="button", padding= "0 10px", fontSize= "16px"}) => {

  return (
    <Container background={background} borderColor={borderColor} color={color} width={width} radius={radius} onClick={handleClick} type={type} padding={padding} fontSize={fontSize} onMouseOver={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {text}
    </Container>
  )
}

export default Button